export default "__VITE_ASSET__3Ze7JoyG__"